import React from "react";
import { Link } from "react-router-dom";

// imports for all images used in dashboard component
// import daysRemainingIcon from "../assets/days-remaining-icon.svg";

// imoprt all Loader components for loading

class NotFound extends React.Component {
  render() {
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
      <h1 className="small">Page Not Found</h1>
      {/* card for registered courses display  */}
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="card text-center justify-content-center align-items-center min-h-500 ">
            <div className="not-found">
              <div className="status-code"> 404 </div>
              <div className="status-text"> Oops! Page Not Found</div>
              <Link
                    className="btn btn-primary btn-primary-color btn-remove-p-r w-100 mt-5"
                    to="/"
                  >
                    Back To Home
                  </Link>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>
      {/* end card for news display   */}
    </main>
    );
  }
}



export default NotFound;
